"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Heart = function Heart(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 16 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 14 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "7F7F7F" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 16 16",
    scale: width / 16,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.218 1.389c.293-.26.617-.484.964-.668A4.06 4.06 0 0 1 11.064.25a4.633 4.633 0 0 1 3.32 1.396 4.788 4.788 0 0 1 0 6.708l-.176.173c-1.182 1.147-5.43 4.959-5.912 5.163l-.293.125-.293-.125c-.467-.198-4.472-3.785-5.798-5.053l-.291-.284a4.788 4.788 0 0 1 0-6.708A4.63 4.63 0 0 1 4.944.25c.655.003 1.3.164 1.88.47.349.185.673.41.966.67l.215.2.214-.201zM7.59 11.733l.412.35.397-.337c1.389-1.197 4.404-3.925 4.914-4.443a3.288 3.288 0 0 0 0-4.606 3.127 3.127 0 0 0-2.246-.947c-.413.002-.819.104-1.184.297-.393.208-.742.49-1.028.83l-.215.271a.974.974 0 0 1-.092.097A.776.776 0 0 1 8 3.46c-.324-.001-.443-.077-.614-.286l-.196-.251-.188-.213a3.472 3.472 0 0 0-.88-.665A2.564 2.564 0 0 0 4.94 1.75c-.424 0-.845.086-1.234.253-.38.164-.724.4-1.014.693a3.288 3.288 0 0 0 0 4.605l.235.229c.883.84 3.415 3.124 4.665 4.203z",
    id: "heart"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#heart"
  }));
};

var _default = Heart;
exports["default"] = _default;
module.exports = exports["default"];